


















































import {Vue, Prop, Component} from 'vue-property-decorator'
import {Letter} from "@/store/models/Letter/Letter";
import {getPersianDate} from "@/util/utils";
import * as api from '@/store/Services/letterServices';
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import * as letterService from '@/store/Services/letterServices';
import { DraftLetter } from '../../../../store/models/Letter/DraftLetter';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import store from '@/store';

@Component
export default class SingleLetterMobile extends Vue{
    @Prop() letterData?: Letter 
    isSent = false;
    isOpenned = false;
    @Prop() serverTime?: string;
    @Prop() isDraft?: boolean;
    async created(){
    if(this.letterData === undefined) return;
         if(this.letterData.sender === null || this.letterData.sender === undefined){
             this.isSent = true;
         }

         store.state.eventHub.$on('letter-type-changed',this.openIfOpen);
         store.state.eventHub.$on('close-finalizeLetter',this.onAssignFinalizeFeatureInSingleLetter)

    }
    openIfOpen(){
        if(!this.letterData)return
        if(this.isOpenned && !this.letterData.isOpenned)
            this.letterData.isOpenned = true;
    }
    get priorityColor(){
        if(this.letterData === undefined)return '';
        if(this.letterData.priority<5)
            return  {'background-color':'#69b578'};
        if(this.letterData.priority === 5)
            return  {'background-color':'#e9c46a'}; 
        else
            return {'background-color':'#ff6b6b'};
    }

    get  sendTime(){
        if(this.letterData === undefined) return '';
        if(!this.serverTime) return '';
        //return getPersianDate(this.letterData.sendTime,'MM/DD',false);
        const dateConverter = new  DateBaseOnCurrentTimeConverter();
        return   dateConverter.getDateString(new Date(this.letterData.sendTime.substring(0,this.letterData.sendTime.length -1)),this.serverTime)
    }

    async select(){
        
        if(this.letterData === undefined)return;
        if(this.isDraft){
           this.$emit("letterselected",this.letterData.letterPossessionId);
        }
        else{
            if(this.letterData.isOpenned === false){
                api.OpenLetter(this.letterData.letterPossessionId);
                //store.state.eventHub.$emit('letter-opened');
                if(this.letterData.isEnterpriseForm)
                   if( await enterpriseFormService.IsFormAutoClose(this.letterData.enterpriseFormId))
                        this.letterData.isClosed = true;
            }
            this.isOpenned = true;
            //this.letterData.isOpenned = true;
            this.$emit("letterselected",this.letterData.letterPossessionId);
        }
    }

    get receiverStr(){
        if(!this.letterData)return '';
        if(!this.letterData.recievers)return '';
        if(this.letterData.recievers.length > 1) return this.letterData.recievers[0].nameOnly + ' و بیشتر...';
        return this.letterData.recievers[0].nameOnly;
    }

     onAssignFinalizeFeatureInSingleLetter(letterPossessionId: string){
        if(this.letterData==null)return;
        const singleletter=this.letterData.letterPossessionId==letterPossessionId;
        if(singleletter){
            this.letterData.isClosed=true;
        }
    }

    get isSentDraft(){
        if(!this.letterData) return false;
        const draftLetter = this.letterData as DraftLetter;
        if(!draftLetter)return false;
        if(!draftLetter.childLetters)return false;
        return draftLetter.childLetters.length > 0 ;
    }

    
}



